import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";

@observer
export class FileLinkButton extends Button {

	render() {
		return <Button {...this.props} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="24,14 24,28 8,28 8,10 16,10 18,8 6,8 6,30 26,30 26,12 " />
					<polygon points="30,2 20.3,2 23.5,5.3 17,11.8 20.3,15 26.8,8.5 30,11.8 " />
				</svg>
			</i>
		</Button>;
	}
}
